import { render, staticRenderFns } from "./MStoreItemsPerPage.vue?vue&type=template&id=77c06a8e&scoped=true&"
import script from "./MStoreItemsPerPage.vue?vue&type=script&lang=ts&"
export * from "./MStoreItemsPerPage.vue?vue&type=script&lang=ts&"
import style0 from "./MStoreItemsPerPage.vue?vue&type=style&index=0&id=77c06a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c06a8e",
  null
  
)

export default component.exports